module.exports = __webpack_public_path__ + "img/yhsj.2a4ced85.png";